module.exports = __webpack_public_path__ + "static/media/beastmaster.1b722e2e.png";